// Centralized logging for the app. debug()/info() are gated behind the app debug flag,
// toggled via "?debug=true" in the URL (cached in localStorage so it stays active across
// SPA navigation until explicitly turned off with "?debug=false"); warn()/error() always surface.
function isDebugFlagEnabled(): boolean {
  const storageKey = "wdp:debug";
  const urlFlag = new URLSearchParams(window.location.search).get("debug");
  if (urlFlag !== null) {
    localStorage.setItem(storageKey, urlFlag === "true" ? "true" : "false");
  }
  return localStorage.getItem(storageKey) === "true";
}

class AppLog {
  debug(...args: unknown[]): void {
    if (isDebugFlagEnabled()) console.log(...args);
  }

  info(...args: unknown[]): void {
    if (isDebugFlagEnabled()) console.info(...args);
  }

  warn(...args: unknown[]): void {
    console.warn(...args);
  }

  error(...args: unknown[]): void {
    console.error(...args);
  }
}

export const appLog = new AppLog();
